import { create } from "zustand";
import { persist } from "zustand/middleware";
import { customStorage } from "../utils/index";
import { getAllCountriesList } from "../utils/countriesUtils.js";

const useCountriesStore = create()(
    persist(
        (set) => ({
            isLoading: false,
            list: [],

            setIsLoading: (isLoading) => set({ isLoading }),

            fetchCountries: async () => {
                await getAllCountriesList(set); // Call the utility function and pass `set` to update state
            },
        }),
        {
            name: "countries-storage", // Store name for persistence (localStorage)
            storage: customStorage, // Use custom localStorage (or sessionStorage)
        }
    )
);

export default useCountriesStore;
